import { Component, Input } from '@angular/core';

export enum IrisCardElevation {
  FLAT = 0,
  ONE = 1
}

@Component({
  selector: 'iris-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  host: {
    class: 'iris-card',
    '[class.iris-card-elevation-1]': 'elevation === 1',
    '[class.iris-card-clickable]': 'clickable',
    '[class.iris-card-disabled]': 'disabled'
  }
})

export class IrisCardComponent {
  @Input() elevation: IrisCardElevation = IrisCardElevation.FLAT;
  @Input() clickable: boolean = false;
  @Input() disabled: boolean = false;
}
